import { Checkbox } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../../../../translations';
import { ReceptionServiceFormController } from '../../ReceptionServiceForm';

type ReceptionServicePriceRangeCheckboxProps = Pick<ReceptionServiceFormController, 'register'> & {
   readonly disabled?: boolean;
};

export const ReceptionServicePriceRangeCheckbox = (props: ReceptionServicePriceRangeCheckboxProps): JSX.Element => {
   return (
      <Checkbox
         testId={'priceRange'}
         label={receptionServiceTranslationKeys.shared.form.components.priceRangeCheckbox.label}
         controller={props.register('priceRangeChecked')}
         disabled={props.disabled}
         defaultValue={false}
      />
   );
};
